import React, { useContext } from "react"; 
import { NavLink } from "react-router-dom";
import { imageURL } from "../../../constants";
import Menus from "./Menus";
import TopHeader from "./TopHeader";
import { DrtContext } from "../../../context/DrtContext";
import ExternalLinkPopup from "../../../services/ExternalLinkPopup";

const Header = () => {
  const {
    externalLink,
    source,
    setSource,
    setExternalLink,
    setExternalLinkPopupShow,
  } = useContext(DrtContext);

  return (
    <header className="wraper" role="banner" aria-label="Site Header">
      <TopHeader />
 {/* <div className="container">
       <div class="scroll-wrapper">
        <div class="scroll-text">
       This is for your information that e-filing & CIS services on www.drt.gov.in will not be available on 17.02.2026 from 8:00 pm to 11:00 pm.
        </div>
       
      </div>
</div>  */}
      <div className="logo-sec-wraper" role="region" aria-label="Site Branding">
        <div className="container">
          <div className="row justify-content-between flex-wrap align-items-center">
            <div className="col-12 col-sm-12 col-md-12 col-lg-7 logo-sec">
              <NavLink to="/" className="logo-align">
                <img src={`${imageURL}/emblem-dark.png`} alt="Government emblem" />
                <div className="brand-text">
                  <div className="brand-toptext">
                    <p>
                      भारत सरकार&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <span> वित्त मंत्रालय वित्तीय सेवाएं विभाग</span>
                    </p>
                    <p>
                      Government of India &nbsp;&nbsp;&nbsp;&nbsp;
                      <span>Ministry of Finance Department of Financial Services</span>
                    </p>
                  </div>
                  <h4>
                    DEBTS RECOVERY APPELLATE TRIBUNALS (DRATs)
                    <span>DEBTS RECOVERY TRIBUNALS (DRTs)</span>
                  </h4>
                </div>
              </NavLink>
            </div>

            <div className="col-12 col-sm-12 col-md-12 col-lg-5 logo-sec text-right" role="region" aria-label="External Links">
              <button
                type="button"
                className="external-link"
                aria-label="Open Swachh Bharat external link"
                onClick={() => {
                  setExternalLinkPopupShow(true);
                  setExternalLink("https://swachhbharat.mygov.in/");
                  setSource("Header");
                }}
              >
                <img src="./images/swach-bharat.png" alt="Swachh Bharat Abhiyan" />
              </button>

              <img
                src="./images/aazadi-ka-amrit-mohotsav.png"
                alt="Azadi Ka Amrit Mahotsav"
              />
            </div>
          </div>
        </div>
      </div>

      {externalLink !== "" && source === "Header" && <ExternalLinkPopup />}

      <nav role="navigation" aria-label="Main Menu">
        <Menus />
      </nav>
    </header>
  );
};

export default Header;
